import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-services',
  template: `<router-outlet></router-outlet>`
})
export class ServicesComponent
{
  constructor(private router: Router)
  {
    if (this.router.url == "/servicios")
    {
      this.router.navigate(['/']);
    }
  }
}
